<template>
  <div 
    id="viewport"
    :style="{ 'height': relativeHeight + 'px' }"
    class="top-left">
    <div 
      id="viewport-inner" 
      :style="innerStyle">
      <header>
        <img src="../assets/REPLAY_logo.svg">
        <p>
          [ + ] To OPEN project<br>
          please select ALL files in the project folder and drag them here
        </p>
      </header>
      <FrameImage/>
      <FlowMap/>
    </div>
    <Timeline/>
    <Toolbar/>
  </div>
</template>

<script>
import FrameImage from './FrameImage'
import FlowMap from './FlowMap'
import Timeline from './Timeline'
import Toolbar from './Toolbar'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Viewport',
  components: {
    FrameImage,
    FlowMap,
    Timeline,
    Toolbar,
  },
  computed: {
    ...mapState(['files']),
    ...mapGetters(['relativeWidth', 'relativeHeight']),
    innerStyle() {
      return {
        width: this.relativeWidth,
        height: this.relativeHeight,
        margin: '0 0 0 -' + this.relativeWidth / 2 + 'px',
      }
    },
  },
}
</script>

<style lang="scss">
#viewport {
  width: 100%;

  #viewport-inner {
    position: absolute;
    top: 0;
    left: 50%;
    width: 100%;
    height: 100%;

    > header {
      text-align: center;
      position: absolute;
      top: 15%;
      left: 50%;
      width: 900px;
      margin: 0 0 0 -450px;

      > p {
        width: 100%;
        color: lightgrey;
        font-size: 150%;
        line-height: 2em;
      }

      > img {
        width: 400px;
        margin: 20% 0 0;
      }
    }
  }
}
</style>
